module.exports = "<todo-show class=\"fn-block\" todo=\"$ctrl.todo\" ng-if=\"$ctrl.todo\"></todo-show>";